import React from "react";
import { shallowEqual } from "react-redux";
import { useBnbSelector } from "../../../../../redux/store";
import BasketFinancePackExtras from "./BasketFinancePackExtras";
import { getSelectedFinancePacksSelector } from "../../../../../utils/selectorUtils";
import * as BasketListStyles from "../../../../../../../../common-deprecated/styles/v2/toyota/custom/basket/BasketList";
import * as Type from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import { BnbLabel } from "../../../../../utils/labels";

const BasketFinancePacks = (): JSX.Element | null => {
    const financePacks = useBnbSelector(getSelectedFinancePacksSelector, shallowEqual);
    const financeOption = useBnbSelector((state) => state.utils.financeOption);

    if (financePacks.length === 0) return null;

    return (
        <BasketListStyles.BasketList>
            {financePacks.map((financePack) => (
                <React.Fragment key={financePack.id}>
                    <BasketListStyles.BasketListItem>
                        <BasketListStyles.ListItemLabel>
                            <Type.SmallText>{financePack.name}</Type.SmallText>
                        </BasketListStyles.ListItemLabel>
                        {financeOption === "monthly" && (
                            <BasketListStyles.ListItemValue>
                                <BasketListStyles.PriceFallback>
                                    <BnbLabel label="financePackIncluded" />
                                </BasketListStyles.PriceFallback>
                            </BasketListStyles.ListItemValue>
                        )}
                    </BasketListStyles.BasketListItem>
                    <BasketFinancePackExtras pack={financePack} />
                </React.Fragment>
            ))}
        </BasketListStyles.BasketList>
    );
};

export default BasketFinancePacks;
